import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';

import ChangePassword from "../../components/ChangePassword";
import PrivacyPolicySettings from "../../components/PrivacyPolicy";
import HelpTab from "../../components/Help";
import PersonalDetails from "../../components/ProfileSettings/PersonalDetails";
import TwoFactorAuth from "../../components/TwoFactorAuth";

const Settings = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [tabValue, setTabValue] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  // Handle URL parameters to set active tab
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tab = urlParams.get('tab');
    
    if (tab === 'two_factor') {
      setTabValue(2); // Two-Factor Auth tab
    }
  }, [location.search]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    
    // Remove tab=two_factor parameter when switching to other tabs
    if (newValue !== 2) { // 2 is the TwoFactorAuth tab index
      const urlParams = new URLSearchParams(location.search);
      urlParams.delete('tab');
      const newSearch = urlParams.toString();
      const newUrl = newSearch ? `${location.pathname}?${newSearch}` : location.pathname;
      navigate(newUrl, { replace: true });
    }
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom color="primary">Settings</Typography>

      <Card sx={{ mb: 0 }}>
        <CardContent sx={{
          p: 0, borderRadius: 3,
          border: "1px solid #cdccf0",
        }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant={isMobile ? "scrollable" : "standard"}
            scrollButtons={isMobile ? "auto" : false}
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              px: 3,
              ".MuiTab-root": {
                textTransform: "none",
                fontWeight: 500,
                minWidth: 100,
              },
            }}
          >
            <Tab label="Personal Details" />
            <Tab label="Change Password" />
            <Tab label="Two-Factor Auth" />
            <Tab label="Privacy & Policy" />
            <Tab label="Help" />
          </Tabs>

          <Box
            sx={{
              p: 3,
            }}
          >
            {tabValue === 0 && <PersonalDetails />}
            {tabValue === 1 && <ChangePassword />}
            {tabValue === 2 && <TwoFactorAuth />}
            {tabValue === 3 && <PrivacyPolicySettings />}
            {tabValue === 4 && <HelpTab />}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Settings;
